const canAccessAffiliateProgram = details => {
  return !!details;
};

export default canAccessAffiliateProgram;
